// extracted by mini-css-extract-plugin
export default {"bigSelectDropdown":"style--bigSelectDropdown--c7d2be","bigOptions":"style--bigOptions--b7b883"};